export default {
  OneOrderOnePayment: {
    Title: 'One order, one payment, many pleasures',
    Body : 'Order from as many stores as you want and you will receive a notification to pick up from each one.'
  }
}
